var angular = require('angular')
var moment = require('moment')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
var dropdown = require('angular-ui-bootstrap/src/dropdown')
require('../responsive-date-picker/responsive-date-picker.component.js')
require('./component.css')

angular.module('ChartFreeRangeCmp', [dropdown, 'ResponsiveDatePickerCmp'])
  .component('chartFreeRange', {
    template: require('./chart-free-range.component.tpl.html'),
    controller: ChartFreeRangeCtrl,
    controllerAs: 'vm',
    bindings: {
      dropDownOptions: '<',
      dropDownIndex: '=',
      dateFrom: '=',
      dateTo: '=',
      onDateRangeChanged: '&',
      ddRf: '@',
      rdpFromRf: '@',
      rdpToRf: '@'
    }
  })

ChartFreeRangeCtrl.$inject = ['i18n', '$timeout', '$scope']

function ChartFreeRangeCtrl (i18n, $timeout, $scope) {
  var vm = this

  vm.$onInit = function () {
    vm.dropdownSelect = dropdownSelect
    vm.dateFrom = null
    vm.dateTo = moment.utc(new Date()).toDate()
    vm.dateChange = dateChange
    vm.selectedType = null
    vm.selectedValue = null
    vm.currentDate = moment.utc().toDate()

    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    dropdownSelect(vm.dropDownIndex)
  }

  function dropdownSelect (index) {
    vm.dropDownIndex = index
    vm.selectedValue = vm.dropDownOptions[vm.dropDownIndex].value
    vm.selectedType = vm.dropDownOptions[vm.dropDownIndex].type
    dateChange()
  }

  $scope.$watch('vm.dropDownIndex', function dateChange (newValue, oldValue) {
    if (newValue !== oldValue) {
      dropdownSelect(vm.dropDownIndex)
    }
  }, true)

  function dateChange () {
    if (vm.selectedType === 'ALL') {
      vm.dateFrom = moment.utc('1970-01-01').toDate()
      vm.dateTo = vm.currentDate
    } else if (vm.selectedType !== 'FREE') {
      vm.dateFrom = moment.utc(vm.dateTo).subtract(vm.selectedValue, vm.selectedType).toDate()
    }
    $timeout(function () {
      vm.onDateRangeChanged()
    })
  }
}
